export default __webpack_public_path__ + "static/media/solDropdown.37465a4e.svg";